import { RouteConfig } from 'vue-router';
import EditPDFPricing from '@/views/damageassessor/EditPDFPricing.vue';
import IndexCompanies from '@/views/damageassessor/IndexCompanies.vue';
import Companies from '@/views/damageassessor/EditCompany.vue';
import PageModal from "@/components/modals/PageModal.vue";

const routes: Array<RouteConfig> = [
	{
		path: '/damageassessor/editpdfpricing/',
		name: 'damageassessor.editpdfpricing',
		component: EditPDFPricing,
	},
	{
		path: '/damageassessor/:type/',
		name: 'damageassessor.IndexCompanies',
		component: IndexCompanies,
	},
	{
		path: '/damageassessor/:type/:id',
		name: 'damageassessor.IndexCompanies.show',
		component: Companies,
	},
];

routes.map(route => {
	route.meta = route.meta || {};
	route.meta.levelGuard = [1, 2];
});

export default routes;
